module.exports = __webpack_public_path__ + "static/img/IMG_0909.a3904f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fotosGaleriaSicarf/IMG_0909.jpg
// module id = ywYr
// module chunks = 11